

import { FinalDimensions, IProduct, PriceBreakdown } from "@/app/types/types";

export const calculateFinalDimensions = (
  product: IProduct, 
  selectedOptions: string[]
): FinalDimensions => {
  
  let finalDimensions: FinalDimensions = {
    length: product.length || 0,
    width: product.width || 0,
    height: product.height || 0,
  };

  const allOptions = product.customization.flatMap(c => c.options);

  for (const optionValue of selectedOptions) {
    const optionData = allOptions.find(o => o.value === optionValue);

    const hasOverride = (optionData?.length ?? null) !== null &&
                        (optionData?.width ?? null) !== null &&
                        (optionData?.height ?? null) !== null;

    if (hasOverride) {
        finalDimensions = {
            length: optionData!.length!,
            width: optionData!.width!,
            height: optionData!.height!,
        };
        break; 
    }
  }

  return finalDimensions;
};

export const calculatePrice = (
    product: IProduct,
    selectedOptions: string[],
    isWholesale: boolean
): PriceBreakdown => {
    
    const basePrice = isWholesale ? product.wholeSalePrice : product.price;


    const optionsPrice = selectedOptions.reduce((acc, optValue) => {
        let optionData = product.customization
            ?.flatMap(c => c.options)
            .find(o => o.value === optValue);
        if (!optionData && optValue.toLowerCase().includes('premium')) {
            const isDoubleMotorPremium = optValue.toLowerCase().includes('double');
            optionData = product.customization
                ?.flatMap(c => c.options)
                .find(o => {
                    const lowerValue = o.value.toLowerCase();
                    return lowerValue.includes('premium') && 
                           (isDoubleMotorPremium ? lowerValue.includes('double') : lowerValue.includes('single'));
                });
            
            if (optionData) {
                console.log('Found premium option by pattern matching:', optionData.value);
            }
        }
            
        if (optionData) {
            const cost = isWholesale 
                ? optionData.wholeSaleAdditionalCost 
                : optionData.additionalCost;
            return acc + (cost || 0); 
        } else {
            const colorMatch = product.colors?.find(c => c.name === optValue);
            if (colorMatch) {
                console.log('Found color:', colorMatch.name, '(no additional cost)');
            } else {
                console.log('  Option not found in product data!');
            }
        }
        
        return acc;
    }, 0);

    
    const subtotal = basePrice + optionsPrice;
    const tax = isWholesale ? subtotal * (product.wholeSaleTax / 100) : 0;
    const total = subtotal + tax;
    return {
        basePrice,
        optionsPrice,
        subtotal,
        tax,
        total,
    };
};